export const Problems = {
  ExistingCustomerSsn: 'Problem.ExistingCustomerSsn',
  ExistingCustomerSsnAndLastnameMismatch: 'Problem.ExistingCustomerSsnAndLastnameMismatch',
  ExistingCustomerIdAndSsnMismatch: 'Problem.ExistingCustomerIdAndSsnMismatch',
  NewCustomerInFlight: 'Problem.NewCustomerInFlight',
  MultipleCustomerCardsForSsn: 'Problem.MultipleCustomerCardsForSsn',
};

export enum CustomerErrorCode {
  SSN_MISMATCH = 'SSN_MISMATCH',
}
